var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fup-input",
    _vm._g(
      _vm._b(
        {
          attrs: { value: _vm.value, number: true, type: "number" },
          on: { input: _vm.input }
        },
        "fup-input",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }